import { Component, OnInit } from '@angular/core';
import { UserProfile, UserSessionService } from 'bna-angular-auth-client';
import { ClientSettingsService } from 'src/app/core/services/auth/client-settings.service';
import { AppSettings } from 'src/app/shared/constants/app-settings.constants';

@Component({
  selector: 'app-user-profile-menu',
  templateUrl: './user-profile-menu.component.html',
  styleUrls: ['./user-profile-menu.component.scss'],
})
export class UserProfileMenuComponent implements OnInit {
  enabled = false;
  isAuthenticated = false;
  profile: UserProfile;

  constructor(
    private userSessionService: UserSessionService,
    private clientSettingService: ClientSettingsService
  ) {
    this.enabled =
      !this.userSessionService.isIntegration &&
      !this.userSessionService.hasSelectedOrganization;
    this.isAuthenticated = this.userSessionService.isAuthenticated();
    this.profile = this.userSessionService.getProfile();
  }
  ngOnInit(): void {
    this.userSessionService.isAuthenticated$.subscribe((result) => {
      if (!result.isAuthenticated) return;
      this.isAuthenticated = result.isAuthenticated;
      this.profile = this.userSessionService.getProfile();
    });
  }

  signOut() {
    this.userSessionService.signOut();
    this.clientSettingService.remove(AppSettings.AgencySelectionPopedUp, false);
  }

  image404ErrorHandler(event) {
    event.target.src = '../../../../assets/images/user.png';
  }
}
